var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ServerSideResult',{attrs:{"test":_vm.fieldAgents}},[_c('v-select',{attrs:{"label":_vm.label,"items":_vm.fieldAgents,"item-value":"id","item-text":"name","rules":_vm.required ? [_vm.requiredRule] : []},on:{"change":_vm.handleChange},model:{value:(_vm.fieldAgentId),callback:function ($$v) {_vm.fieldAgentId=$$v},expression:"fieldAgentId"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }